import React , {useState , useEffect } from 'react'

import { Tooltip as ReactTooltip } from "react-tooltip";




import { Row , Col, Form} from 'react-bootstrap'



import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmarkCircle } from '@fortawesome/free-solid-svg-icons'

import logohh from '../../images/logo-hh-login.svg'


import HtmlEditor from '../LoadExcel/HtmlEditor';


import axios from 'axios'








export default function ProductoInput( { claveProd , prodText , claveUnidad ,  showSearch , showUnidad , myUnidad}) {


    var obj = {
        clave : null ,
        prodservicio : null 
    }

    const [fullData,setFullData] = useState( obj )
    const [editData,setEditData] = useState( "")
    const [showEditor,setShowEditor] = useState( false ) ;
    const [theProdText,setTheProdText] = useState( "")
    const [theUnidad,setTheUnidad] = useState( "")
    const [errMsg,setErrMsg] = useState( "")



    function changeEditor( )
    {
        setShowEditor( !showEditor) ;
    }

    function onSubmit( e )
    {

        e.preventDefault() ; // codigo , prodservicio

        var codigo = document.getElementById( "codigo").value ;

        if ( codigo === "" ){
            setErrMsg( "No existe codigo")
            return ;
        }

        var prodservicio = document.getElementById( "prodservicio").value ;

        var unidad = document.getElementById( "unidad").value ;
        var clave = document.getElementById( "clave").value ;

        var descripcion = document.getElementById( "descripcion").value ;

        var punitario = document.getElementById( "punitario").value ;

        var tivatasa = document.getElementById( "tivatasa").value ;

        var tiepstasa = document.getElementById( "tiepstasa").value ;

        var tiepscuota = document.getElementById( "tiepscuota").value ;
        
        var rivatasa = document.getElementById( "rivatasa").value ;
        // riepstasa
        var riepstasa = document.getElementById( "riepstasa").value ;
        
        var riepscuota = document.getElementById( "riepscuota").value ;
        
        var risrtasa = document.getElementById( "risrtasa").value ;
        

        var obj = {

            codigo : codigo ,
            clave_producto_servicio : prodservicio ,
            CLAVE_UNIDAD : clave ,
            unidad : unidad ,
            descripcion : descripcion ,
            precio_unitario :punitario ,
            t_iva_tasa : tivatasa ,
            t_ieps_tasa : tiepstasa ,
            T_IEPS_CUOTA : tiepscuota ,
            R_IVA_TASA : rivatasa ,
            R_IEPS_TASA : riepstasa ,
            R_IEPS_CUOTA : riepscuota ,
            R_ISR_TASA : risrtasa ,
            dTimeStamp : getFormatDate( new Date())


        }

        console.log( "Objeto = " + JSON.stringify( obj ) ) ;


        axios.post(  "http://localhost:3004/livefactura/catproductos" , JSON.stringify( obj )  , {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json'
            } })
        .then( (response) => {

            console.log( "La respuesta = " + JSON.stringify( response ) )

        }).catch((err)=>{

        })
        

    }

    function setClose()
    {

    }


    function setnOpennings( e )
    {

    }

    function onTheChange( e )
    {
        console.log( "Name = " + e.target.id )
        console.log( "value = " + e.target.value ) ;

        if ( e.target.id === "clave" )
        {
            fullData.clave = e.target.value ;
        }

        if ( e.target.id === "prodservicio" )
        {
            fullData.prodservicio = e.target.value ;
        }

        setFullData( fullData )

   
    }


    useEffect( () => {

        console.log( "fullData = " + JSON.stringify( fullData))


        console.log( "Cambiando theProdtext " + prodText) ;

        setTheProdText( prodText ) ;

        setTheUnidad( myUnidad ) ;

        // var prod = document.getElementById('prodservicio')

        // prod.addEventListener("focusout", (event) => {
        //     //event.target.style.background = "";

        //     console.log( "focusOut = " + event.target.id ) ;

        //     //showSearch( false ) ;
        //   });

    } ,[fullData,prodText,myUnidad])


    function onFocusProducto( e )
    {
        console.log( "onFocusProducto " + e.target.id ) ;

        showSearch( true ) ;
    }

    function onFocusUnidad( e )
    {
        console.log( "onFocusUnidad " )

        showUnidad( true ) ;


    }


    function onMouseClaveProd( e )
    {
        console.log( "El mouse entrado ")
    }

    function onMouseClaveProdLeave( e )
    {
        console.log( "El mouse saliendo") ;
    }

    function getFormatDate(d) {
        var date = new Date(d);
        var dateStr =
            date.getFullYear() + "-" +
            ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
            ("00" + date.getDate()).slice(-2) + " " +
            ("00" + date.getHours()).slice(-2) + ":" +
            ("00" + date.getMinutes()).slice(-2) + ":" +
            ("00" + date.getSeconds()).slice(-2);
        //console.log(dateStr);
    
        return dateStr;
    }
    

  return (
    <div className='d-flex flex-column justify-content-center box-1 backemployer-2 centersearch'>
        <div className='my-5'>
            <a href='#'><img ms-auto src={logohh} alt="logohh"/></a>
        </div>


            <div className='d-flex flex-column justify-content-center box-1 backemployer-2 mb-5 form-2'  id="page1">

                <Row>
                <Col className='col-8'>
                    <h4>Agrega Producto Servicio</h4>
                </Col>
                <Col className='col-3'>
                    {/* { pData && <VacancyAddPost  open={postState} func={setPostState} ></VacancyAddPost> } */}
                </Col>
                <Col className='col-1'>
                    <FontAwesomeIcon className='pt-2 ps-2' onClick={setClose} icon={faXmarkCircle} 
                    title='Close' style={{color:'blue' , height:25 }}/>
                </Col>

                </Row>





                <form className='pt-1' onSubmit={onSubmit} style={{width:'90h'}}  > 

                    <div className='row'>

                        <div className='col-sm-6'>
                            <div className="form-group"  style={{width: "100%"  }} >
                                <label className="form-label m-0" htmlFor="codigo">Código</label>
                                <input type="text" className="form-group p-lg-2" id="codigo"  
                                placeholder="Código"  onChange={onTheChange} 
                                />
                                
                            </div>
                        </div>
                        <div className='col-sm-6 '>
                            <div className="form-group" style={{width: "100%" , height : "30px"  }}>
                                <label className="form-label m-0" htmlFor="prodservicio">Clave Producto Servicio</label>
                                <input    type="text" id="prodservicio" value={claveProd}
                                className="form-control p-lg-2" placeholder='Producto Servicio'
                                onChange={(e) => setnOpennings(e.target.value)} 
                                onFocus={onFocusProducto} 
                                data-tooltip-id="my-tooltip-2"/>
                            </div>
                        </div>
                        <ReactTooltip
                            id="my-tooltip-2"
                            place="bottom"
                            variant="info"
                            content={theProdText}
                        />


                    </div>

                    

                    <div className='row'>



                        <div className='col-sm-6'>
                            <div className="form-group"  style={{width: "100%" , height : "30px"  }} >
                                <label className="form-label m-0" htmlFor="unidad">Unidad</label>
                                <input type="text" className="form-group p-lg-2" id="unidad"  
                                placeholder="Unidad" onFocus={onFocusUnidad} value={theUnidad}
                                />
                                
                            </div>
                        </div>


                        <div className='col-sm-6'>
                            <div className="form-group"  style={{width: "100%"  }} >
                                <label className="form-label m-0" htmlFor="clave">Clave Unidad</label>
                                <input type="text" className="form-group p-lg-2" id="clave"  value={claveUnidad}
                                placeholder="Clave Unidad" onChange={onTheChange}
                                />
                                
                            </div>
                        </div>




                    </div>


                    <div className='row'>     

 
                        
                            <div className='col'>

                            
                                <div className="form-group"  >
                                    <label className="m-0" htmlFor="descripcion">Descripcion</label>
                                    <textarea type="textarea" className="form-control" id="descripcion"  
                                    placeholder="Descripción"  maxLength={120} size= {100}
                                    />
                                    
                                </div>
                            </div>

                    </div>




                    <div className='row'>


                        <div className='col-sm-6'>
                            <div className="form-group"  style={{width: "100%"  }} >
                                <label className="form-label m-0" htmlFor="punitario">Precio Unitario</label>
                                <input type="number" className="form-group p-lg-2" id="punitario"  
                                placeholder="Precio Unitario"  
                                />
                                
                            </div>
                        </div>


                        <div className='col-sm-6'>
                            <div className="form-group"  style={{width: "100%"  }} >
                                <label className="form-label m-0" htmlFor="tivatasa">T_IVA_TASA</label>
                                <input type="number" step="0.01" className="form-group p-lg-2" id="tivatasa"  
                                placeholder="tivatasa"  
                                />
                                
                            </div>
                        </div>



                    </div>


                    <div className='row'>


                        <div className='col-sm-6'>
                            <div className="form-group"  style={{width: "100%"  }} >
                                <label className="form-label m-0" htmlFor="tiepstasa">T_IEPS_TASA</label>
                                <input type="number" className="form-group p-lg-2" id="tiepstasa"  
                                placeholder="T_IEPS_TASA"  
                                />
                                
                            </div>
                        </div>


                        <div className='col-sm-6'>
                            <div className="form-group"  style={{width: "100%"  }} >
                                <label className="form-label m-0" htmlFor="tiepscuota">T_IEPS_CUOTA</label>
                                <input type="number" className="form-group p-lg-2" id="tiepscuota"  
                                placeholder="T_IEPS_CUOTA" 
                                />
                                
                            </div>
                        </div>



                    </div>


                    <div className='row'>


                        <div className='col-sm-6'>
                            <div className="form-group"  style={{width: "100%"  }} >
                                <label className="form-label m-0" htmlFor="rivatasa">R_IVA_TASA</label>
                                <input type="number" className="form-group p-lg-2" id="rivatasa"  
                                placeholder="R_IVA_TASA" 
                                />
                                
                            </div>
                        </div>


                        <div className='col-sm-6'>
                            <div className="form-group"  style={{width: "100%"  }} >
                                <label className="form-label m-0" htmlFor="riepstasa">R_IEPS_TASA</label>
                                <input type="number" className="form-group p-lg-2" id="riepstasa"  
                                placeholder="T_IEPS_CUOTA" 
                                />
                                
                            </div>
                        </div>



                    </div>
                    


                    <div className='row'>


                        <div className='col-sm-6'>
                            <div className="form-group"  style={{width: "100%"  }} >
                                <label className="form-label m-0" htmlFor="riepscuota">R_IEPS_CUOTA</label>
                                <input type="number" className="form-group p-lg-2" id="riepscuota"  
                                placeholder="R_IEPS_CUOTA"  
                                />
                                
                            </div>
                        </div>


                        <div className='col-sm-6'>
                            <div className="form-group"  style={{width: "100%"  }} >
                                <label className="form-label m-0" htmlFor="risrtasa">R_ISR_TASA</label>
                                <input type="number" className="form-group p-lg-2" id="risrtasa"  
                                placeholder="R_ISR_TASA" 
                                />
                                
                            </div>
                        </div>



                    </div>

                    <div className='col-sm-1'>
                        <button onClick={changeEditor} type="button" className="btn btn-primary mt-3 button-3"  >HtmlEditor</button> 
                    </div>

                    { showEditor && (
                        <HtmlEditor theId={"edit"} title={"CV del empleado"} theContent={editData}
                        setTheContent={setEditData}></HtmlEditor>
                    )

                    }


                    <div className='col-sm-1'>
                        <button type="submit"  className="btn btn-primary mt-3 button-3"  >Submit</button> 
                    </div>

                    { errMsg !== "" && (

                        <p >Se presento error {errMsg}</p>
                    )

                    }


                    



                </form> 


    </div>
    </div>

  )
}
